export default __webpack_public_path__ + "static/media/sign_up_middle_down_new.d068e38b.png";